/**
 * Phần thuần của bước chụp ảnh ở màn Định danh: phân loại lỗi camera và kiểm kích thước trước khi gửi.
 *
 * ## Năm lý do camera không mở, không gộp làm một
 *
 * `getUserMedia` chỉ có trong **ngữ cảnh bảo mật** (HTTPS, `localhost`). Qua HTTP thường, `navigator.mediaDevices`
 * là `undefined` và trình duyệt **chưa từng hỏi quyền** — gộp mọi lỗi thành "hãy cho phép camera" là bắt người dùng
 * đi tìm một biểu tượng quyền không có trên thanh địa chỉ (UI_RECONSTRUCTION_SPEC §8, `camera.ts`).
 *
 * Phân loại theo `DOMException.name` — thứ duy nhất ổn định giữa các trình duyệt; `message` đã được dịch và đổi
 * theo trình duyệt.
 */

export type LyDoCamera = 'KHONG_BAO_MAT' | 'TU_CHOI' | 'KHONG_CO_THIET_BI' | 'DANG_BAN' | 'KHAC';

export function phanLoaiLoiCamera(loi: unknown, baoMat: boolean): LyDoCamera {
  if (!baoMat) return 'KHONG_BAO_MAT';
  const ten = (loi as { name?: unknown } | null)?.name;
  switch (ten) {
    case 'NotAllowedError':
    case 'SecurityError':
      return 'TU_CHOI';
    case 'NotFoundError':
    case 'OverconstrainedError':
      return 'KHONG_CO_THIET_BI';
    case 'NotReadableError':
    case 'AbortError':
      return 'DANG_BAN';
    default:
      return 'KHAC';
  }
}

/**
 * Cạnh ngắn tối thiểu — **chép có chủ ý** từ `CANH_NGAN_TOI_THIEU` của máy chủ (`modules/ekyc/backend/src/tep/anh.ts`)
 * để người dùng biết **trước khi** tải lên. Máy chủ vẫn là cổng thật; hai số lệch nhau thì máy chủ thắng.
 */
export const CANH_NGAN_TOI_THIEU = 480;

/**
 * Ảnh có đủ lớn không. Không đọc được kích thước (`null`, ví dụ HEIC trên trình duyệt không giải được) thì **cho
 * qua**: máy chủ đọc được, chặn ở đây là chặn sai.
 */
export function quaNho(kichThuoc: { rong: number; cao: number } | null): boolean {
  if (!kichThuoc || !kichThuoc.rong || !kichThuoc.cao) return false;
  return Math.min(kichThuoc.rong, kichThuoc.cao) < CANH_NGAN_TOI_THIEU;
}

/**
 * Tỉ lệ khung căn giấy tờ — thẻ khổ ID-1 (85,6 × 54 mm, ISO/IEC 7810) như CCCD, GPLX. Hộ chiếu mở hai trang gần
 * khổ ID-3, nhưng trang thông tin vẫn vừa khung này; khung chỉ để căn, không cắt ảnh.
 */
export const TI_LE_THE = 85.6 / 54;
